import { AddClientProduct } from './AddClientProduct'

export default AddClientProduct
